import React from "react";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";

const FreeGames = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10 text-[#00F0FF]">
      <Helmet>
        <title>Free Online Games - No Downloads | BrowserArena</title>
        <meta name="description" content="Enjoy free online games instantly on BrowserArena. No downloads or installs required — just play and have fun!" />
        <link rel="canonical" href="https://browserarena.com/free-games" />
      </Helmet>

      <h1 className="text-3xl font-bold mb-4">Play Free Online Games</h1>
      <p className="mb-4">
        Tired of downloading and installing games? At <strong>BrowserArena</strong>, you can play <strong>hundreds of free games</strong> online, instantly in your browser.
      </p>
      <p className="mb-4">
        Whether you're into <Link to="/games/action" className="text-[#FF007F] underline">action games</Link>, <Link to="/games/puzzle" className="text-[#FF007F] underline">puzzle games</Link>, or even <Link to="/games/arcade" className="text-[#FF007F] underline">classic arcade</Link>, we have a game for everyone.
      </p>
      <p className="mb-4">
        Our games work on both desktop and mobile devices, thanks to modern <strong>HTML5 technology</strong>. Just open your browser, choose a game, and enjoy.
      </p>
      <p className="mb-4">
        Want to explore top picks? Visit our <Link to="/best-browser-games" className="text-[#FF007F] underline">Best Browser Games</Link> page.
      </p>
    </div>
  );
};

export default FreeGames;

